import { eventBus } from '@mtfe/sweet-utils';

const indexWmWelfareReady = (isShowShangou) => {
    eventBus.$onceOn('indexWmWelfareReady', () => {
        eventBus.$emit('WelfareWaimaiModuleReady');
        if (isShowShangou) {
            eventBus.$emit('TabReady');
            eventBus.$emit('ShangouModulesReady');
        }
    });
};

export default indexWmWelfareReady;
